/* eslint-disable @typescript-eslint/no-empty-function */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export abstract class ServiceBusController {
    constructor() {}
}
